module.exports = __webpack_public_path__ + "static/media/28-iveco-mercedes.eda162e6.jpg";